import Search from './../classes/search';

$(window).on('ready load', function () {
  // Initialize Search
  new Search();
});



// WEBPACK FOOTER //
// ./scripts/global/search.js